import request from "@/utils/request.js";

// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/sex?regionId=1
// 实有人口-性别
export const sex = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/sex",
    params: data || {}
  });
};
// 实有人口-人口一致标识
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/houseHoldType?regionId=0
export const houseHoldType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/houseHoldType",
    params: data || {}
  });
};

// 实有人口-人口一致标识-未婚
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/marital?regionId=0
export const marital = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/marital",
    params: data || {}
  });
};
// 实有人口-名族
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/nation?regionId=0
export const nation = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/nation",
    params: data || {}
  });
};
// 实有人口-户籍类型
//http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/populationType?regionId=0
export const populationType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/populationType",
    params: data || {}
  });
};
// 实有人口-总数
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/count?regionId=0
export const count = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/count",
    params: data || {}
  });
};
// 实有人口-地区分布
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/region?regionId=0&type=0
export const region = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/region",
    params: data || {}
  });
};
// 实有人口-年龄结构
// http://180.167.172.122:6405/hz-smart-community/data/analyse/prison/ageType?regionId=0
export const ageType = data => {
  return request({
    url: "/api/hz-smart-community/data/analyse/prison/ageType",
    params: data || {}
  });
};





// 实有人口-人口一直标识
export const securitysave = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/save",
    data: data || {},
    method: "POST"
  });
};

